// removed by extract-text-webpack-plugin
module.exports = {"wordRow":"oldLayerBlock__wordRow___1yX2-","centeredOneBlock":"oldLayerBlock__centeredOneBlock___hXlke","centeredTwoBlock":"oldLayerBlock__centeredTwoBlock___2S1U-","centeredThreeBlock":"oldLayerBlock__centeredThreeBlock___2iCO1","centeredFourBlock":"oldLayerBlock__centeredFourBlock___1LyaC","centeredFiveBlock":"oldLayerBlock__centeredFiveBlock___3j_QY","centeredDynamicBlock":"oldLayerBlock__centeredDynamicBlock___Ul9n9","wordColumnBlock":"oldLayerBlock__wordColumnBlock___2IOPx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/oldLayerBlock.css
// module id = 232
// module chunks = 0